import { createUseStyles } from 'react-jss';
import { GLOBAL_LETTER_SPACING } from '@/styles/themes/components';
export const useOfferBlockStyles = createUseStyles((theme) => ({
    coverageList: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: -6,
        marginTop: 12,
    },
    coverageItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '10px 0',
        '&:not(:last-child)': {
            borderBottom: `1px solid ${theme.colors.textBackground}`,
        },
    },
    coverageInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    coverageLabel: {
        fontSize: 13,
        fontWeight: 500,
        color: theme.colors.sky,
        letterSpacing: GLOBAL_LETTER_SPACING,
    },
    coverageAmount: {
        fontWeight: 700,
        fontSize: 20,
        color: theme.colors.brand,
        flexShrink: 0,
        letterSpacing: '0.1px',
    },
    perHour: {
        fontWeight: 700,
        fontSize: 20,
        letterSpacing: '0.1px',
    },
    coverageCondition: {
        fontSize: 12,
        fontWeight: 400,
        color: theme.colors.textPrimary,
        letterSpacing: GLOBAL_LETTER_SPACING,
    },
}), { name: 'offer-block' });
